import React from 'react';
import {HashRouter, Routes, Route, Navigate} from 'react-router-dom';
import {ConfigProvider, Layout} from 'antd';
import LoginScreen from './screens/Login';
import ForgotPasswordScreen from './screens/ForgotPassword';
import NavBar from './components/NavBar';
import AddIngredientForm from './screens/AddIngredientForm';
import Profile from './screens/Profile';
import Brands from './screens/Brands';
import Providers from './screens/Providers';
import CustomFormTable from './screens/CustomFormTable';
import EditIngredientForm from './screens/EditIngredientForm';
import AddFormulation from './screens/AddFormulation';
import FormulationList from './screens/FormulationList';
import EditFormulation from './screens/EditFormulation';
import AddActiveForm from './screens/ActiveForm';
import EditActiveForm from './screens/ActiveFormEdit';
import ActivesList from './screens/ActiveList';
import AddWarningForm from './screens/WarningsForm';
import WarningFormEdit from './screens/WarningsFormEdit';
import WarningsList from './screens/WarningsList';
import AddClaimForm from './screens/ClaimsForm';
import ClaimFormEdit from './screens/ClaimsFormEdit';
import ClaimsList from './screens/ClaimsList';
import StaticFormEdit from './screens/StaticsFormEdit';
import StaticsList from './screens/StaticsList';
import {theme, colors} from './theme';
const {Content} = Layout;

const RequireAuth: React.FC<{
  children: JSX.Element;
}> = ({children}) => {
  const authToken = localStorage.getItem('authToken');
  if (!authToken) {
    return <Navigate to="/login" />;
  }

  return (
    <div>
      <NavBar />
      <div style={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
        <Content style={{flex: 1, marginTop: 64}}>{children}</Content>
        <div style={{textAlign: 'center', padding: '6px 24px', borderTop: `1px solid ${colors.border}`, background: '#fff'}}>
          <span style={{fontSize: 12, lineHeight: '20px', color: colors.footerText}}>Umbrella Group ®</span>
        </div>
      </div>
    </div>
  );
};

const protectedRoutes = [
  {path: '/', element: <CustomFormTable />},
  {path: '/profile', element: <Profile />},
  {path: '/ingredients', element: <CustomFormTable />},
  {path: '/ingredients/new', element: <AddIngredientForm />},
  {path: '/ingredients/:id/edit', element: <EditIngredientForm />},
  {path: '/actives', element: <ActivesList />},
  {path: '/actives/new', element: <AddActiveForm />},
  {path: '/actives/:id/edit', element: <EditActiveForm />},
  {path: '/warnings', element: <WarningsList />},
  {path: '/warnings/new', element: <AddWarningForm />},
  {path: '/warnings/:id/edit', element: <WarningFormEdit />},
  {path: '/claims', element: <ClaimsList />},
  {path: '/claims/new', element: <AddClaimForm />},
  {path: '/claims/:id/edit', element: <ClaimFormEdit />},
  {path: '/statics', element: <StaticsList />},
  {path: '/statics/:id/edit', element: <StaticFormEdit />},
  {path: '/formulations', element: <FormulationList />},
  {path: '/formulations/new', element: <AddFormulation />},
  {path: '/formulations/:id/edit', element: <EditFormulation />},
  {path: '/brands', element: <Brands />},
  {path: '/providers', element: <Providers />},
];

const App: React.FC = () => {
  return (
    <ConfigProvider theme={theme}>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/forgot-password" element={<ForgotPasswordScreen />} />

          {protectedRoutes.map((route) => {
            return <Route key={route.path} path={route.path} element={<RequireAuth>{route.element}</RequireAuth>} />;
          })}
        </Routes>
      </HashRouter>
    </ConfigProvider>
  );
};

export default App;
